<template>
    <popup :show="true" width="669px" @on-close="onClose">
        <div class="title">版型信息</div>
        <div class="pattern-form-body">
            <div class="pattern-form-container">
                <div class="type-tag">客供版型</div>
                <Upload
                    action="/"
                    :data="{ dir: 'template' }"
                    :before-upload="(file)=>onBeforeUpload(file,'pattern_file')"
                    :show-upload-list="false"
                >
                    <div class="upload-pattern-file">
                        <img v-if="form.path && util.test_image(form.path)" :src="form.path | default_img" class="file-icon" />
                        <img v-else :src="util.get_image_icon(form.path)" alt="" class="file-icon"> {{form.file_name}}
                    </div>
                </Upload>
                <div class="form-label required">版型名称:</div>
                <div class="form-value">
                    <input type="text" v-model="form.name" placeholder="请输入版型名称">
                </div>
                <div class="form-label">适用性别:</div>
                <div class="form-radio-value">
                    <RadioGroup v-model="form.sex">
                        <Radio label="男">男</Radio>
                        <Radio label="女">女</Radio>
                    </RadioGroup>
                </div>
                <div class="form-two-col">
                    <div class="col-item">
                        <div class="form-label required">面料耗量(M):</div>
                        <div class="form-value">
                            <input type="number" placeholder="请输入需要面料耗量" v-model="form.consumption">
                        </div>
                    </div>
                    <div class="col-item">
                        <div class="form-label">里料耗量(M):</div>
                        <div class="form-value">
                            <input type="number" placeholder="请输入需要里料耗量" v-model="form.consumption2">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="spec-file-list" v-if="form.guige_name && form.guige_path">
            <div class="spec-file">
                <div class="file-info">
                    <img v-if="form.guige_path && util.test_image(form.guige_path)" :src="form.guige_path|default_img" alt="" class="file-icon" />
                    <img v-else :src="util.get_image_icon(form.guige_path)" class="file-icon" />
                    {{form.guige_name}}
                </div>
                <Icon type="md-close" class="cursor" @click="onSpecFileDel" />
            </div>
        </div>
        <Upload
            action="/"
            :data="{ dir: 'template' }"
            :before-upload="(file)=>onBeforeUpload(file,'pattern_detail')"
            :show-upload-list="false"
        >
            <div class="upload-spec cursor">
                <img class="icon" src="@/assets/images/team/icon-team-upload-blue.png" alt="">
                <span>上传规格表</span>
            </div>
        </Upload>
        <div class="btn-box">
            <div class="cancel-btn" @click="onClose">取消</div>
            <div class="confirm-btn" @click="onConfirmCreate">确认上传</div>
        </div>
    </popup>
</template>
<script> 
import { teamFileCreate, teamFileMove } from '@/api/index';
import Popup from '@/components/Popup.vue';
import { uploadFileToOSS } from "@/utils/oss";
import util from '@/utils/util';
export default {
  name:"PatternForm",
  components: {
    Popup,
  },
  props:{
    file:{
        type:Object,
        default:()=>{}
    },
    teamId:{
        type:String,
        default:''
    },
    folderId:{
        type:String,
        default:''
    }
  },
  data(){
    return{
        form:{
            name:'',
            path:'',
            file_name:'',
            guige_name:'',
            guige_path:'',
            consumption:'',
            consumption2:'',
            sex:''
        },
        type:'',
        util
    }
  },
  mounted(){
    console.log('temp-file',this.file);
    this.type = this.file.file_type;
    this.form.name = this.file.name;
    this.form.file_name = this.file.name;
    this.form.path = this.file.path;
  },
  methods:{
    async onPatternMoveIn(){
        try{
            const param = {};
            param.team_uuid = this.teamId;
            param.parent_directory_uuid = this.file.folder_uuid;
            param.file_uuid = this.file.file_uuid;
            param.type = 51;
            param.info = this.form;
            console.log('param-move-pattern',param);
            const {code,msg} = await teamFileMove(param);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.$emit('on-success');
            this.onClose();
        }catch(e){
            console.log('err-move-pattern',e);
            this.$layer.msg(e.msg);
        }
    },
    async onConfirmCreate(){
        try{
            if(this.file.is_move){
                this.onPatternMoveIn();
                return;
            }
            const param = {};
            param.team_uuid = this.teamId;
            param.directory_uuid = this.folderId;
            param.type = this.type;
            param.info = this.form;
            console.log('param==>create_pattern',param);
            const {code,msg} = await teamFileCreate(param);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.$emit('on-success');
            this.onClose();
        }catch(e){
            console.log('err-create-pattern',e);
            this.$layer.msg(e.msg);
        }
    },
    onSpecFileDel(){
        this.form.guige_name = '';
        this.form.guige_path = '';
    },
    async onBeforeUpload(file, field) { 
        const url = await uploadFileToOSS(file,'template');
        if(field === 'pattern_file'){
            this.form.name = file.name;
            this.form.file_name = file.name;
            this.form.path = url;
        }else{
            this.form.guige_name = file.name;
            this.form.guige_path = url;
        }
        return false;
    },
    onClose(){
        console.log('aaa');
        this.$emit('on-close',true);
    }
  }
};
</script>
<style scoped lang="scss">
.title{
    color:#1a1a1a;
    font-size:24px;
    line-height:44px;
    width:100%;
    text-align:center;
}
.pattern-form-body{
    width:100%;
    padding:0 30px;
    .pattern-form-container{
        background:#fafafa;
        border-radius:5px;
        position:relative;
        padding:0 20px 30px 20px;
        width:100%;
        display:flex;
        flex-direction:column;
        .type-tag{
            position:absolute;
            top:0;
            left:0;
            background:#000000;
            border-radius:5px 0 5px 0;
            color:#ffffff;
            width:70px;
            height:25px;
            line-height:25px;
            text-align:center;
        }
        ::v-deep .ivu-upload{
            width:100% !important;
        }
        .upload-pattern-file{
            width:100%;
            background:#ffffff;
            border-radius:5px;
            border:1px solid #e0e0e0;
            padding:10px;
            display:flex;
            align-items:center;
            column-gap:10px;
            color:#1d1d1d;
            font-size:14px;
            font-weight:bold;
            margin-top:42px;
            cursor:pointer;
            .file-icon{
                width:32px;
                height:32px;
            }
        }
        .form-label{
            color:#4d4d4d;
            font-size:14px;
            margin-top:25px;
            &.required{
                &::after{
                    content:'*';
                    color:#ff4d4f;
                    margin-left:4px;
                }
            }
        }
        .form-value{
            width:100%;
            height:44px;
            border:1px solid #d1d1d1;
            border-radius:5px;
            overflow:hidden;
            margin-top:12px;
            input{
                width:100%;
                height:100%;
                border:none;
                outline:none;
                padding:0 15px;
            }
        }
        .form-radio-value{
            margin-top:12px;
            display:flex;
            column-gap:50px;
        }
    }
}
.spec-file-list{
    width:100%;
    padding:0 30px;
    margin-top:10px;
    .spec-file{
        width:100%;
        background:#fafafa;
        border-radius:5px;
        // border:1px solid #e0e0e0;
        display:flex;
        align-items:center;
        justify-content:space-between;
        padding:10px 30px;
        .file-info{
            display:flex;
            align-items:center;
            column-gap:10px;
            color:#1d1d1d;
            font-size:14px;
            flex:1;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            .file-icon{
                width:32px;
                height:32px;
            }
        }
    }
}
.upload-spec{
    display:flex;
    align-items:center;
    column-gap:10px;
    color:#629ffa;
    font-size:14px;
    margin-left:40px;
    margin-top:29px;
    .icon{
        width:20px;
        height:20px;
    }
}
.form-two-col{
    display:flex;
    column-gap:20px;
    .col-item{
        flex:1;
    }
}
.btn-box{
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    column-gap:10px;
    margin:40px 0;
    .cancel-btn{
        width:150px;
        height:38px;
        border-radius:8px;
        border:1px solid #e5e5e5;
        text-align:center;
        line-height:38px;
        color:#333333;
        font-size:14px;
        cursor:pointer;
    }
    .confirm-btn{
        width:180px;
        height:38px;
        line-height:38px;
        border-radius:8px;
        text-align:center;
        color:#ffffff;
        background:#ff5967;
        font-size:14px;
        cursor:pointer;
    }
}

::v-deep .ivu-radio-checked .ivu-radio-inner{
    border-color:#ff5967;
    &::after{
        background-color:#ff5967;
    }
}
::v-deep .ivu-radio-focus{
    box-shadow:none;
    -webkit-box-shadow:none;
}
</style>